import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';

const useDataFetch = (apiEndpoint, initialSearchQuery) => {
  const [dataset, setDataset] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery || {});
  const [isClearing, setIsClearing] = useState(false);

  const fetchData = async (page) => {
    // クエリが未設定ならフェッチしない
    if (!searchQuery || typeof searchQuery !== 'object') return;

    setLoading(true);
    setError(null);
    try {
      const params = { page, ...searchQuery };
      const response = await axiosInstance.get(apiEndpoint, { params });
      setDataset(response.data.data || response.data || []);
      setCurrentPage(response.data.currentPage || 1);
      setTotalPages(response.data.totalPages || 1);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'データの取得に失敗しました');
      setDataset([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchQuery || typeof searchQuery !== 'object') return;
    fetchData(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (!isClearing || !searchQuery || typeof searchQuery !== 'object') return;

    if (currentPage === 1) {
      fetchData(1);
    } else {
      setCurrentPage(1);
    }

    setIsClearing(false);
  }, [searchQuery, isClearing, initialSearchQuery]);

  const handleSearchChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSearchQuery((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSearchSubmit = () => {
    if (!searchQuery || typeof searchQuery !== 'object') return;
    setCurrentPage(1);
    fetchData(1);
  };
  const handleClearSearch = () => {
    setIsClearing(true);
    setSearchQuery(initialSearchQuery || {});
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return {
    dataset,
    setDataset,
    loading,
    error,
    currentPage,
    totalPages,
    searchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
    refetch: fetchData,
  };
};

export default useDataFetch;